/**
 * Server-side sortable table headers for Vuesax `vs-table`.
 *
 * Vuesax sorts client-side by default (only the current page). With the `sst`
 * ("server-side table") prop, clicking a sortable `vs-th` instead emits
 * `@sort(key, sortType)` — where sortType cycles null → 'asc' → 'desc' → null —
 * so we can re-fetch the whole result set sorted by that column.
 *
 * Usage in a list component that already has `sortBy`, `currentPage`, a
 * `sortParams` getter and an async `getRecords()`:
 *   - `mixins: [serverSort]`
 *   - on `<vs-table>`: add `sst` and `@sort="handleSort"`
 *   - on each sortable `<vs-th>`: add `sort-key="<entityField>"` — the column's
 *     underlying, server-sortable entity column (e.g. "docNo", "status",
 *     "createdAt", "totalPayableAmount"). Leave action/computed columns without
 *     a sort-key so they stay non-sortable.
 *
 * The third click (sortType null) reverts to the component's default sort,
 * `$data.defaultSortBy` when present, otherwise `{ updatedAt: 'DESC' }`.
 */
export default {
  methods: {
    handleSort(key, sortType) {
      if (key && sortType) {
        this.sortBy = { [key]: String(sortType).toUpperCase() }
      } else {
        this.sortBy = { ...(this.defaultSortBy || { updatedAt: 'DESC' }) }
      }
      this.currentPage = 1
      this.getRecords()
    },
  },
}
